import axios from "axios";

export const API = axios.create({
 baseURL: "https://nexaglobaladmin-api.skyapi.store/",
   // baseURL: "http://localhost:5409/",
});
